import { render, staticRenderFns } from "./RecruiterQaAdmin.vue?vue&type=template&id=cc5e0270&scoped=true"
import script from "./RecruiterQaAdmin.vue?vue&type=script&lang=js"
export * from "./RecruiterQaAdmin.vue?vue&type=script&lang=js"
import style0 from "./RecruiterQaAdmin.vue?vue&type=style&index=0&id=cc5e0270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5e0270",
  null
  
)

export default component.exports